import React from "react";
import MenuItem from "../components/MenuItem";
import logo from "../assets/img/icons/logo.svg";
import locks from "../assets/img/icons/locks.svg";
import specialSales from "../assets/img/icons/special-sales.svg";
import tools from "../assets/img/icons/tools.svg";
import presaleAlerts from "../assets/img/icons/presale-alerts.svg";
import kycAudit from "../assets/img/icons/kyc-audit.svg";
import docs from "../assets/img/icons/docs.svg";

export default function Sidebar({ page }) {
  return (
    <div id="sidebar">
      <div className="top">
        <a href="/" className="logo">
          <img src={logo} alt="Logo" />
        </a>
        <div className="right">
          <a className="title" href="/">
            Cryptomine Space X
          </a>
          <a className="default-btn" href="/">
            Buy $Viltrumita
          </a>
        </div>
      </div>
      <div className="menu">
        {/* MenuItem Create Token */}
        <MenuItem
          page={page}
          logo={tools}
          title={"Create Token"}
          subtitles={[
            {
              name: "Create Token",
              page: 52,
              link: "/tools/create_token",
            },
          ]}
        />

        {/* MenuItem Special Sales */}
        <MenuItem
          page={page}
          logo={specialSales}
          title={"Special Sales"}
          subtitles={[
            {
              name: "Explore",
              page: 20,
              link: "/special_sales/explore",
            },
            {
              name: "My Contributions",
              page: 21,
              link: "/special_sales/my_contributions",
            },
            {
              name: "My Alarms",
              page: 22,
              link: "/special_sales/my_alarms",
            },
          ]}
        />

        {/* Resto de los elementos del menú */}
        <MenuItem
          page={page}
          logo={locks}
          title={"Locks"}
          subtitles={[
            {
              name: "Create Lock",
              page: 40,
              link: "/locks/create_lock",
            },
            {
              name: "Token Lock",
              page: 41,
              link: "/locks/token_lock",
            },
            {
              name: "Liquidity Lock",
              page: 42,
              link: "/locks/liquidity_lock",
            },
          ]}
        />

        {/* Resto de elementos del menú */}
        {/* ... */}

        {/* Otros elementos del menú */}
        <a className="title" href="https://t.me/CSPX_Ecosystem">
          <div className="logo">
            <img src={presaleAlerts} alt="Presale Alerts" />
          </div>
          <span>Presale Alerts</span>
        </a>
        <a className="title" href="/">
          <div className="logo">
            <img src={kycAudit} alt="KYC & Audit" />
          </div>
          <span>KYC & Audit</span>
        </a>
        <a
          className="title"
          href="https://cryptominespacex.gitbook.io/cryptomine-space-x-road-map/"
        >
          <div className="logo">
            <img src={docs} alt="Docs" />
          </div>
          <span>Docs</span>
        </a>
      </div>
      <div className="bottom"></div>
    </div>
  );
}
